import { List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { MprcRequestErrorReport, MprcSpinnerIndicator } from "components";
import { MprcFilterEmptyDataset } from "components/filter/MprcFilterEmptyDataset";
import { MprcBoxDrawer } from "components/MprcBoxDrawer";
import { UnitTypeResponse } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////////

export type UnitTypeDrawerResult = {
    unitTypeId: string;
    name: string;
};

interface IPros {
    title?: string;
    subtitle?: string;
    onClose: (unitType: UnitTypeDrawerResult | undefined) => void;
}

/////////////////////////////////////////////////////////////////////////////////

export const UnitTypeSelectionDrawer: React.FC<IPros> = (props) => {

    const { title, subtitle, onClose } = props;

    const api = useCoreApi();
    const { t } = useTranslation();

    const [loading, setLoading] = useState<boolean>(true);
    const [viewError, setViewError] = useState<any>();
    const viewData = useRef<UnitTypeResponse[] | null>(null);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    useEffect(() => {

        async function getData() {
            try {
                var result = await api.v1.unitType.getUnitTypes();
                viewData.current = result.data;
            }
            catch (e) {
                setViewError(e);
                viewData.current = null;
            }

            setLoading(false);
        }

        if (loading) getData();

    }, [loading]);


    return (
        <MprcBoxDrawer
            onClose={() => onClose(undefined)}
            title={title || t("Unit.UnitTypeSelectionDrawer.Title")}
            subtitle={subtitle}
            content={
                <>
                    <MprcRequestErrorReport error={viewError} />

                    {
                        loading
                            ? <MprcSpinnerIndicator />
                            : viewData.current && viewData.current.length === 0
                                ? <MprcFilterEmptyDataset message={t("Unit.UnitTypeSelectionDrawer.ListEmptyMessage")} />
                                : (
                                    <List disablePadding>
                                        {
                                            viewData.current?.map((v, index) => (
                                                <ListItem disablePadding key={index}>
                                                    <ListItemButton onClick={() => onClose(v)}>
                                                        <ListItemText primary={v.name} primaryTypographyProps={{ variant: "h5", color: "highlight.main" }} />
                                                    </ListItemButton>
                                                </ListItem>
                                            ))
                                        }
                                    </List>
                                )
                    }
                </>
            }
        />
    );
};
